export const resetTurnstile = () => {
  if (!window.turnstile) return;

  window.turnstile.reset();
};

export type TurnstileObject = {
  reset: () => void;
};
